import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from 'src/app/shared/toast/toast.service';
import { CurrentUserService } from 'src/app/user/services';
import { PartnerSystem } from '../models';
import { PartnerSystemService } from '../services/partner-system.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoPopupModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

@Component({
    selector: 'ep-partner-systems',
    templateUrl: './partner-systems.component.html',
    styleUrls: ['./partner-systems.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoPopupModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule, DxTemplateModule]
})
export class PartnerSystemsComponent implements OnInit, AfterViewInit {

  partnerSystems: PartnerSystem[] = [];

  allowAdding = false;
  allowUpdating = false;
  allowDeleting = false;
  allowShowLog = false;

  constructor(
    private partnerSystemService: PartnerSystemService,
    private loadingPanelService: LoadingPanelService,
    private toastService: ToastService,
    private currentUserService: CurrentUserService) {
  }

  ngOnInit(): void {
    this.allowAdding = this.currentUserService.hasPermission('Partner_Action_SystemsCreate');
    this.allowUpdating = this.currentUserService.hasPermission('Partner_Action_SystemsEdit');
    this.allowDeleting = this.currentUserService.hasPermission('Partner_Action_SystemsDelete');
    this.allowShowLog = this.currentUserService.hasPermission('Partner_Action_SystemsShowLog');
  }

  async ngAfterViewInit(): Promise<void> {
    await this.refresh();
  }

  async refresh(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading...');

      this.partnerSystems = [];
      this.partnerSystems = await this.partnerSystemService.getAllPartnerSystems();
    }
    catch (err) {
      console.error(err);
      this.toastService.showToast('Failed to load data...', ToastType.error);
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  onInitNewRow(e: any): void {
    e.data = new PartnerSystem();
  }

  async onRowInsertedOrUpdated(e: any): Promise<void> {
    const item = e.data as PartnerSystem;

    try {
      item.Id = (await this.partnerSystemService.savePartnerSystem(item))?.Id ?? item.Id;
      this.toastService.showToast('Partner system saved...', ToastType.success);
    }
    catch (err) {
      console.error(err);
      this.toastService.showToast('Failed to save partner system ...', ToastType.error);
    }
  }

  async onRowRemoving(e: any): Promise<void> {
    const item = e.data as PartnerSystem;

    const deferred = $.Deferred();
    e.cancel = deferred.promise();

    try {
      await this.partnerSystemService.deletePartnerSystem(item.Id);
      this.toastService.showToast('Partner system deleted...', ToastType.success);
      deferred.resolve(false);
    }
    catch (err) {
      console.error(err);
      this.toastService.showToast('Failed to delete partner system ...', ToastType.error);
      deferred.resolve(true);
    }
  }
}
